import React, { useState, useEffect, useRef } from 'react';
import './Home.css';
import logo from '../assets/images/logo.png'; // 1. Importe o logo aqui
import heroImage from '../assets/images/hero.png'; // Importa a nova imagem do hero
import sobrenosImage from '../assets/images/sobrenos.jpg'; // Importa a nova imagem da seção "Sobre Nós"
import frangoAssadoImage from '../assets/images/frangoassado.jpeg'; // Importa a imagem de frango assado
import diaDiaImage from '../assets/images/diadia.jpg'; // Importa a imagem de carnes do dia a dia
import frangoRecheadoImage from '../assets/images/frangodessossado.png';
import paletaPururucaImage from '../assets/images/paleta.png';
import costelaLegumesImage from '../assets/images/costela.png';
import maminhaRecheadaImage from '../assets/images/maminha.jpg';
import rocamboleCarneImage from '../assets/images/rocambolecarne.png';
import rocamboleFrangoImage from '../assets/images/rocambolefrango.jpg';


// Simulação de ícones para redes sociais
const InstagramIcon = () => <span aria-label="Instagram">📸</span>;
const FacebookIcon = () => <span aria-label="Facebook">📘</span>;

// Componente da Navbar
const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Define 'scrolled' se a rolagem for maior que 50px
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`} role="navigation" aria-label="Menu principal">
      <a href="/" className="navbar-brand">
        <img src={logo} alt="Logo Casa de Carnes Bom Jesus" className="navbar-logo" />
      </a>
      <div className="navbar-links">
        <a href="#sobre">Sobre Nós</a>
        <a href="#produtos">Produtos</a>
        <a href="#assados">Assados</a>
        <a href="#contato">Contato</a>
      </div>
      <a href="https://wa.me/553598464896?text=Olá!%20Gostaria%20de%20fazer%20um%20pedido." className="whatsapp-button-nav" target="_blank" rel="noopener noreferrer" aria-label="Fazer pedido pelo WhatsApp">
        Peça pelo WhatsApp
      </a>
    </nav>
  );
};

// Componente para os cards de valor
const ValueCard = ({ title, description, icon }) => (
  <article className="value-card">
    <span className="value-icon" aria-hidden="true">{icon}</span>
    <h3>{title}</h3>
    <p>{description}</p>
  </article>
);

// Componente para os cards de produto
const ProductCard = ({ title, description, imageUrl }) => (
  <article className="product-card">
    <div 
      className="product-card-image" 
      style={{ backgroundImage: `url(${imageUrl})` }}
      aria-label={title}
    ></div>
    <div className="product-card-content">
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  </article>
);

const FeaturedRoastCard = ({ title, description, imageUrl, altText }) => (
  <article className="roast-card">
    <div 
      className="roast-card-image" 
      style={{ backgroundImage: `url(${imageUrl})` }}
      role="img"
      aria-label={altText}
    ></div>
    <div className="roast-card-content">
      <h3>{title}</h3>
      <p>{description}</p>
      <button className="btn-details" aria-label={`Ver detalhes sobre ${title}`}>
        Ver Detalhes
      </button>
    </div>
  </article>
);

const FeaturedRoastsSection = () => {
  const roastsData = [
    {
      title: "Frango Assado Tradicional",
      description: "O favorito de domingo! Frango com nosso tempero exclusivo e assado cuidadosamente para uma pele dourada e carne suculenta.",
      imageUrl: frangoAssadoImage,
      altText: "Frango assado simples"
    },
    {
      title: "Frango Desossado Recheado",
      description: "Assado no ponto, desossado e recheado com nossa farofa com bacon ou presunto e queijo. Sabor extra para surpreender a família.",
      imageUrl: frangoRecheadoImage,
      altText: "Frango assado recheado"
    },
    {
      title: "Paleta Suína Pururuca",
      description: "A perfeição do contraste: carne que desmancha no garfo por ter sido assada por dois dias, com um courinho crocante e pururucado. Simplesmente inesquecível!",
      imageUrl: paletaPururucaImage,
      altText: "Paleta suína assada"
    },
    {
      title: "Costela com Legumes",
      description: "A costela mais macia, com nosso tempero caseiro, assada junto com batatas e cenouras fresquinhas. Um prato completo, delicioso e pronto para a sua mesa!",
      imageUrl: costelaLegumesImage,
      altText: "Costela assada com legumes"
    },
    {
      title: "Maminha Recheada",
      description: "Um corte nobre recheado com especiarias e acompanhamentos. O toque da Bom Jesus para domingos especiais.",
      imageUrl: maminhaRecheadaImage,
      altText: "Maminha de boi recheada"
    },
    {
      title: "Rocambole de Carne",
      description: "A nossa receita tradicional: carne moída com tempero caseiro, enrolada e recheada com queijo e presunto. Farto e delicioso para o almoço de família.",
      imageUrl: rocamboleCarneImage,
      altText: "Rocambole de carne moída assado"
    },
    {
      title: "Rocambole de Frango",
      description: "Opção leve, saborosa e super prática. Filé de frango moído, recheado e assado, ideal para quem busca uma refeição saudável sem abrir mão do sabor caseiro.",
      imageUrl: rocamboleFrangoImage,
      altText: "Rocambole de frango recheado e fatiado"
    },

  ];

  // Duplica os cards para o efeito de loop infinito
  const duplicatedRoasts = [...roastsData, ...roastsData];
  const scrollContainerRef = useRef(null);
  const isScrollingRef = useRef(false); // Para evitar múltiplos cliques durante a animação

  // Efeito para posicionar o carrossel no início da segunda metade (para o loop)
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
    // A rolagem inicial é metade da largura total, que corresponde ao início da segunda lista de cards
    container.scrollLeft = container.scrollWidth / 2;
  }, []);

  const scroll = (direction) => {
    if (scrollContainerRef.current && !isScrollingRef.current) {
      isScrollingRef.current = true;
      const container = scrollContainerRef.current;
      
      // Calcula o valor do scroll dinamicamente
      // Pega a largura do primeiro card + o gap (espaçamento)
      const firstCard = container.querySelector('.roast-card');
      const scrollAmount = firstCard ? firstCard.offsetWidth + 30 : 330;

      container.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });

      // Função para verificar a posição e liberar o clique
      const handleScrollEnd = () => {
        const { scrollLeft, scrollWidth, clientWidth } = container;
        const scrollContentWidth = scrollWidth / 2;

        // Se chegou perto do final da lista (rolando para a direita)
        if (scrollLeft >= scrollWidth - clientWidth - 1) { // -1 para margem de erro
          container.style.scrollBehavior = 'auto'; // Desativa a animação para o salto
          container.scrollLeft = scrollContentWidth - clientWidth; // Salta para o início da segunda metade
          container.style.scrollBehavior = 'smooth'; // Reativa a animação
        }
        // Se chegou perto do início da lista (rolando para a esquerda)
        else if (scrollLeft <= 0) {
          container.style.scrollBehavior = 'auto';
          container.scrollLeft = scrollContentWidth;
          container.style.scrollBehavior = 'smooth';
        }

        isScrollingRef.current = false;
      };

      // Ouve o evento 'scrollend' para saber quando a animação terminou
      container.addEventListener('scrollend', handleScrollEnd, { once: true });
    }
  };

  return (
    <section className="featured-roasts-section" id="assados">
      <div className="section-header">
        <h2>Assados Artesanais Prontos</h2>
        <p>
          Preparados com tempero exclusivo e assados lentamente para garantir suculência e um sabor que derrete na boca. Qual é o seu favorito?
        </p>
      </div>
      <div className="roasts-wrapper">
        <button className="scroll-arrow left" onClick={() => scroll('left')} aria-label="Rolar para a esquerda">&#8249;</button>
        <div className="roasts-container" ref={scrollContainerRef}>
            {duplicatedRoasts.map((roast, index) => (
              <FeaturedRoastCard key={index} {...roast} />
            ))}
        </div>
        <button className="scroll-arrow right" onClick={() => scroll('right')} aria-label="Rolar para a direita">&#8250;</button>
      </div>
      <a href="https://wa.me/553598464896?text=Ol%C3%A1!%20Quais%20s%C3%A3o%20os%20assados%20prontos%20de%20hoje%3F" className="btn-section-cta" target="_blank" rel="noopener noreferrer">Ver Assados Disponíveis Hoje</a>
    </section>
  );
};

function Home() {
  const currentYear = new Date().getFullYear();

  // Schema Markup para SEO Local
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Butcher",
      "name": "Casa de Carnes Bom Jesus",
      "image": "URL_DO_LOGO_AQUI",
      "description": "Açougue em Paraisópolis MG com carnes frescas, cortes nobres e assados artesanais desde 2016. Delivery de carnes e produtos para churrasco.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Rua Silviano Brandão, 415",
        "addressLocality": "Paraisópolis",
        "addressRegion": "MG",
        "postalCode": "37660-000",
        "addressCountry": "BR"
      },
      "telephone": "+55-35-98464896",
      "priceRange": "$$",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          "opens": "08:00",
          "closes": "20:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Sunday",
          "opens": "08:00",
          "closes": "12:30"
        }
      ],
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "-22.4153",
        "longitude": "-45.7238"
      },
      "sameAs": [
        "https://www.instagram.com/casa_de_carnes_bom_jesus_2016/",
        "https://www.facebook.com/casadcarnesBomJesus/"
      ]
    });
    document.head.appendChild(script);

    // Meta tags dinâmicas
    document.title = "Casa de Carnes Bom Jesus | Açougue em Paraisópolis MG - Carnes Frescas e Assados";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Açougue Casa de Carnes Bom Jesus em Paraisópolis MG. Carnes frescas diariamente, cortes nobres, assados artesanais e churrasco. Delivery pelo WhatsApp. Desde 2016.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'açougue paraisópolis, casa de carnes, carnes frescas, churrasco, cortes nobres, açougue perto de mim, delivery de carne, assados, picanha, costela, frango assado');
    }

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <Navbar />
      <main className="home-page">
        {/* Seção Banner (Hero) */}
        <header className="hero-section">
          <div className="hero-image-col" style={{ backgroundImage: `url(${heroImage})` }}></div>
          <div className="hero-content">
            <img src={logo} alt="Logo Casa de Carnes Bom Jesus" className="hero-logo" />
            <h1>
              Casa de Carnes Bom Jesus <br />
            </h1>
            <h2>
              Tradição e o atendimento amigo de Paraisópolis - MG.
            </h2>
            <p>
              Desde 2016, nossa família seleciona o que há de mais fresco para sua mesa. Encontre cortes para o dia a dia, carnes nobres para o churrasco e peça nossos deliciosos assados no final de semana. <br />
              Delivery em toda Paraisópolis, MG.
            </p>
            <div className="hero-buttons">
              <a 
                href="https://wa.me/553598464896?text=Olá!%20Gostaria%20de%20comprar%20carnes%20frescas." 
                className="btn btn-primary"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Pedir carnes frescas pelo WhatsApp"
              >
                Peça Carnes Frescas Agora
              </a>
             
            </div>
          </div>
        </header>

        {/* Seção Valores */}
        <section className="values-section" aria-label="Nossos diferenciais">
          <ValueCard 
            icon="🥩"
            title="Carnes Frescas Diariamente" 
            description="Recebemos carnes selecionadas todos os dias. Frescor garantido do nosso açougue para sua casa." 
          />
          <ValueCard 
            icon="👨‍👩‍👧‍👦"
            title="Atendimento Familiar" 
            description="Você é mais que um cliente, é parte da nossa família. Açougueiros experientes para cortes personalizados." 
          />
          <ValueCard 
            icon="⭐"
            title="Qualidade Superior" 
            description="Excelência em carnes com preço justo. Os melhores cortes para churrasco e para o dia a dia." 
          />
        </section>

        {/* Seção Sobre (SEO) */}
        <section className="about-section" id="sobre">
          <div className="about-container">
            <div className="about-text-col">
              <h2>A tradição familiar Bom Jesus</h2>
              <p>Desde 2016, a Casa de Carnes Bom Jesus é mais do que um açougue: somos um ponto de encontro em Paraisópolis, MG. Fundados com o propósito de levar o máximo frescor e qualidade para a sua mesa, mantemos a simplicidade e o atendimento personalizado de um negócio familiar.</p>
              <p>Nossos colaboradores dedicados e nossos açougueiros experientes estão prontos para oferecer os cortes perfeitos para cada ocasião. Prezamos pelo frescor diário, seja para as carnes do dia a dia, seja para os cortes nobres do seu churrasco, incluindo nossos assados artesanais de sabor inconfundível.</p>
              <p>Venha nos visitar no coração de Paraisópolis, na Rua Silviano Brandão, 415, e experimente o atendimento amigo que transforma clientes em vizinhos. Se preferir, conte com o nosso serviço de delivery de carnes na região. A qualidade é nossa tradição.</p>
            </div>
            <div className="about-image-col" style={{ backgroundImage: `url(${sobrenosImage})` }}></div>
          </div>
        </section>

        {/* Seção Produtos (Preview) */}
        <section className="products-preview-section" id="produtos">
          <h2>O sabor que você precisa, a qualidade que você merece.</h2>
          <div className="product-cards-container">
          <ProductCard 
              title="Cortes para Churrasco" 
              description="A picanha perfeita, a costela suculenta e cortes especiais que transformam seu churrasco em uma celebração."
              imageUrl="https://images.unsplash.com/photo-1551028150-64b9f398f678?fit=crop&w=800&q=80"
            />
            
            <ProductCard 
              title="Carnes Frescas do Dia a Dia" 
              description="Qualidade inquestionável para o seu almoço de família. Carnes sempre frescas e preparadas com sabor."
              imageUrl={diaDiaImage}
            />
            
            <ProductCard 
              title="Assados Prontos para Levar" 
              description="O sabor da tradição em minutos! Nossos assados artesanais prontos para a sua mesa."
              imageUrl={frangoAssadoImage}
            />
            
       </div>
          <a 
          href="https://wa.me/553598464896?text=Ol%C3%A1!%20Gostaria%20de%20fazer%20um%20pedido%20ou%20pedir%20uma%20dica%20de%20corte." 
          className="btn-section-cta"
          target="_blank"
          rel="noopener noreferrer"
          >
          Faça seu pedido
          </a>
          </section>

        {/* Seção Assados em Destaque */}
        <FeaturedRoastsSection />

        {/* Footer Atualizado */}
        <footer className="footer" id="contato">
          <div className="footer-columns-container">
            {/* Coluna 1: Institucional */}
            <div className="footer-col footer-col-logo">
              <div className="footer-logo">CASA DE CARNES BOM JESUS</div>
              <p className="footer-slogan">Açougue em Paraisópolis MG - Qualidade desde 2016</p>
              <div className="footer-social-links">
                <a 
                  href="https://www.instagram.com/casa_de_carnes_bom_jesus_2016/" 
                  aria-label="Siga-nos no Instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <InstagramIcon />
                </a>
                <a 
                  href="https://www.facebook.com/casadcarnesBomJesus/" 
                  aria-label="Curta nossa página no Facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FacebookIcon />
                </a>
              </div>
            </div>

            {/* Coluna 2: Links Rápidos */}
            <div className="footer-col">
              <h4>Navegação</h4>
              <ul>
                <li><a href="#home">Home</a></li>
                <li><a href="#sobre">Sobre o Açougue</a></li>
                <li><a href="#produtos">Carnes e Produtos</a></li>
                <li><a href="#assados">Assados Bom Jesus</a></li>
                <li><a href="#contato">Contato e Delivery</a></li>
              </ul>
            </div>

            {/* Coluna 3: Contato e Horário */}
            <div className="footer-col">
              <h4>Fale Conosco - Açougue Paraisópolis</h4>
              <address style={{fontStyle: 'normal'}}>
                <p>📍 Rua Silviano Brandão, 415 - Centro</p>
                <p>Paraisópolis - MG, 37660-000</p>
                <p>WhatsApp: <a href="https://wa.me/553598464896">(35) 98464-896</a></p>
                <p className="footer-hours">
                  <strong>Horário de Funcionamento:</strong><br/>
                  Segunda a Sábado: 8h às 20h<br/>
                  Domingo: 8h às 12h30
                  </p>
              </address>
            </div>
          </div>

          {/* Linha Inferior (Legal) */}
          <div className="footer-bottom-bar">
            <p>
              <a href="#termos">Termos de Uso</a> | <a href="#politica">Política de Privacidade</a>
            </p>
            <p>
              © {currentYear} Casa de Carnes Bom Jesus - Açougue em Paraisópolis MG. Todos os direitos reservados.
            </p>
          </div>
        </footer>
      </main>
    </>
  );
}

export default Home;